import { ChangeDetectorRef, Component, HostListener, ViewChild, inject } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { ShowComponent } from 'src/app/common/component/show.component';
import { ComponentCanDeactivate } from 'src/app/common/pending-changes.guard';
import { GroupOfferPriceComponent } from './group-offer-price/group-offer-price.component';
import { GroupOfferTermsComponent } from './group-offer-terms/group-offer-terms.component';
@Component({
	selector: 'app-group-offer',
	templateUrl: './group-offer.component.html',
	styleUrls: ['./group-offer.component.css'],
})
export class GroupOfferComponent extends ShowComponent implements ComponentCanDeactivate {
	@ViewChild(GroupOfferPriceComponent) terms: GroupOfferPriceComponent;
	@ViewChild(GroupOfferTermsComponent) child: GroupOfferTermsComponent;
	@HostListener('window:beforeunload') canDeactivate(): Observable<boolean> | boolean {
		const haveUnpublicated = this.terms.offerTerm.find((item) => item.termPrice && item.termPrice.status == 'D');
		return !this.editable && this.child.termsToGenerate.length === 0 && !haveUnpublicated;
	}

	pageTitle = 'Grupa ofert';
	pageFunction = 'edit';
	dateRange: any = {
		lower: null,
		upper: null,
	};

	data = {
		id: null,
		name: null,
		stopSale: false,
		sale: false,
		www: false,
		merlinx: false,
		priceSetting: 0,
		promotion: false,
		groupProducts: [],
		displayedProducts: [],
	};
	products: Array<any> = [];
	locations: Array<any> = [];
	currency: Array<any> = [];
	board: Array<any> = [];
	priceOption: Array<any> = [];
	priceSetting: Array<any> = [];
	productsForFilters;
	groupOfferTerm: Array<any> = [];
	priceSettingUrl = '';
	protected apiType = 'bag';
	protected parentComponent = 'groupOffer';
	protected apiUrlAdd = '/offer/group_offer/';
	protected itemsBeforeDataLoad = 0;
	protected state = 'primaryData';
	protected getApiUrl(): string {
		return this.apiUrlAdd + this.data.id + '/';
	}
	protected selectedTab = new FormControl(0);

	private readonly cdr = inject(ChangeDetectorRef);

	setDefaultTab(): void {
		this.selectedTab = new FormControl(0);
	}

	protected async loadBefore(): Promise<void> {
		const result: any[] = await Promise.all([
			new Promise((res) => this.bag.get('/product/?limit=999', res)),
			new Promise((res) => this.bag.get('/location/?limit=9999', res)),
			new Promise((res) => this.bag.get('/currency/?limit=999', res)),
			new Promise((res) => this.bag.get('/board/?limit=999', res)),
			new Promise((res) => this.bag.get('/offer/price_option/', res)),
		]);

		this.products = result[0].results;
		this.locations = result[1].results;
		this.currency = result[2].results;
		this.board = result[3].results;
		this.priceOption = result[4].results;

		this.priceOption.map((obj) => {
			if (obj.method === 'C') {
				obj.method = 'PLN';
			} else {
				obj.method = '%';
			}
		});

		if (this.data.id === null) {
			this.loadData();
			this.cdr.detectChanges();
			return;
		}

		this.bag.get(`/offer/group_offer/${this.data.id}/`, (result) => {
			if (result.priceSetting) {
				this.bag.get(`/offer/price_setting/${result.priceSetting}/`, (result) => {
					this.priceSetting = result;
					this.loadData();
					this.cdr.detectChanges();
				});
			} else {
				this.loadData();
				this.cdr.detectChanges();
			}
		});
	}

	protected convertData(data: any): any {
		this.dateRange = data.dateRange;
		delete data.dateRange;
		return data;
	}

	protected afterLoadData(): void {
		this.data.displayedProducts = this.data.groupProducts.map((obj) => {
			return obj.product;
		});

		if (this.data.id === null) {
			return;
		}

		this.bag.get(
			`/offer/term/?group_offer=${this.data.id}&product=${this.data.displayedProducts}&limit=9999`,
			(result, error) => {
				this.groupOfferTerm = result.results;
				this.productsForFilters = result.results;
			},
		);
	}

	protected submitBefore(): void {
		if (this.data.priceSetting === 0) {
			this.data.priceSetting = null;
		}
		this.data.groupProducts = this.data.displayedProducts.map((obj) => {
			const found = this.data.groupProducts.find((el) => el.product == obj);
			if (found) {
				return found;
			}
			return { product: obj };
		});
	}
	protected submitAfter(): void {
		this.parentComponent = 'groupOffer';
		this.afterLoadData();
	}

	protected changeState(value): void {
		this.state = value;
	}

	protected doAdd(): void {
		this.bag.post(this.apiUrlAdd, this.submitConvert(this.data), (result, error) => {
			this.data = result;
			this.afterSend(result, error);
		});
	}

	protected doEdit(): void {
		this.bag.put(this.apiUrl, this.submitConvert(this.data), (result, error) => {
			this.data = result;
			this.afterSend(result, error);
		});
	}
}
